module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/131-chile-04f87cca0d62b26c7ba819df3b8ab57a.svg";